import {
	makeCancelButtonRenderer,
	makeNextButtonRenderer,
	makePreviousButtonRenderer,
} from "./makeFooterButtons.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Default footer for the WizardWidget.
 *
 * @param {Wizard} wizard - Wizard to act upon
 */
export default class WizardFooterWidget extends Widget {
	constructor({ wizard, cancelCallback = () => wizard.aborted.trigger() }) {
		super(...arguments);

		this._wizard = wizard;

		this._cancelCallback = cancelCallback;

		this._wizard.currentStepChanged.register(() => this.update());
		this._wizard.currentStepCompleted.register(() => this.update());
	}

	renderContentOn(html) {
		html.div(
			{ class: "WizardFooter" },
			makeCancelButtonRenderer({
				cancelCallback: this._cancelCallback,
			}),
			html.div(
				{ klass: "form-group text-right" },
				makePreviousButtonRenderer({ wizard: this._wizard }),
				makeNextButtonRenderer({ wizard: this._wizard }),
			),
		);
	}
}
